import ArticleLayout from '@/components/feature/ArticleLayout';

export default function ReviewArticle() {
  return (
    <>
      <title>Superbuy Spreadsheet Review 2026: Is It Worth Using for International Shopping?</title>
      <meta name="description" content="Honest Superbuy Spreadsheet review for 2026 — we examine category organization, product discovery, pricing accuracy, and whether Superbuy Sheet truly helps international shoppers find better deals. Complete pros and cons analysis." />
      <meta name="keywords" content="superbuy spreadsheet review, superbuy sheet review, is superbuy spreadsheet worth it, superbuy spreadsheet honest review, superbuy spreadsheet pros and cons, superbuy spreadsheet 2026 review" />
      <link rel="canonical" href={`${import.meta.env.VITE_SITE_URL || 'https://superbuyspread.makeup'}/superbuy-spreadsheet-review`} />
      <ArticleLayout slug="superbuy-spreadsheet-review" />
    </>
  );
}